import { render, staticRenderFns } from "./DC_ZY_3.vue?vue&type=template&id=02512fc0&scoped=true"
import script from "./DC_ZY_3.vue?vue&type=script&lang=js"
export * from "./DC_ZY_3.vue?vue&type=script&lang=js"
import style0 from "./DC_ZY_3.vue?vue&type=style&index=0&id=02512fc0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02512fc0",
  null
  
)

export default component.exports